import { z } from 'zod';

import { BorrowerId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const EditBorrowerEvent = BaseLoanEvent.extend({
  type: z.literal('editBorrower'),
  borrower: z.object({
    id: BorrowerId,
    name: z.string(),
  }),
  comment: z.string().optional(),
});
export type EditBorrowerEvent = z.infer<typeof EditBorrowerEvent>;
